import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import { ClockTickProvider } from './contexts/ClockTickContext.jsx';
// Self-hosted subset fonts (Inter UI + Roboto Mono timecodes). woff2 live in
// /public/fonts and are declared in fonts.css — no CDN / external request, so a
// poor-connectivity truck can never fail a font fetch mid-show.
import './fonts.css';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ClockTickProvider>
      <App />
    </ClockTickProvider>
  </React.StrictMode>
);
